import React from "react";
import * as s from "./about-box.module.less";
import cn from "classnames";


const AboutBox = ({
	name,
	img,
	role,
    roleDescription,
	description,
	imageAtBottom = false,
 }) => {
	return (
		<div key={name} className={cn(s.teamMember, {
			[s.reverse]: imageAtBottom
		})}>
			<img src={img} alt={name} className={s.teamMemberImg}/>
			<div className={s.teamInfo}>
				<h5>{name}</h5>
				<span title={roleDescription}>{role}</span>
				<p>{description}</p>
			</div>
		</div>
	)
}
export default AboutBox;
